import React from 'react'
import { Outlet } from 'react-router-dom'

const CandidateInterviewTracker = () => {
  return (
    <><Outlet/></>
  )
}

export default CandidateInterviewTracker